import {inject, Injectable} from "@angular/core";
import {UserSessionRepository} from "../../../common/repositories/user-session.repository";
import {AppMenuItem} from "../_models/AppMenuItem";
import {MenuItems} from "../_data/MenuItems";
import {Helper} from "../../../common/helpers/Helper";
import {AccessControlService} from "../../../common/services/access-control.service";

@Injectable()
export class AppNavigationService {

  private readonly userSessionRepository = inject(UserSessionRepository);
  private readonly accessControlService = inject(AccessControlService);

  constructor() {
    // empty
  }

  createMenuItems(): Array<AppMenuItem> {
    let menuItems: Array<AppMenuItem> = [];

    if(this.userSessionRepository.isSeeUser()) {
      menuItems.push(...this.createSeeUserMenuItems());
    }
    else {
      menuItems.push(...this.createExternalUserMenuItems());
    }

    menuItems = this.filterMenuItemsByAccess(menuItems);

    this.resetMenuItemStates(menuItems);

    return menuItems;
  }

  resetMenuItemStates(menuItems: Array<AppMenuItem>): void {
    menuItems.forEach((menuItem: AppMenuItem) => {
      menuItem.expanded = false;
      menuItem.active = false;

      if(menuItem.type === 'parent-item') {
        menuItem.children.forEach((childMenuItem: AppMenuItem) => {
          childMenuItem.parent = menuItem;
          childMenuItem.expanded = false;
          childMenuItem.active = false;
        });
      }
    });
  }

  protected createSeeUserMenuItems(): Array<AppMenuItem> {
    return [
      Helper.clone(MenuItems.Dashboard),
      Helper.clone(MenuItems.Alerts),
      Helper.clone(MenuItems.Insights),
      Helper.clone(MenuItems.Resources),
      Helper.clone(MenuItems.Administration),
      Helper.clone(MenuItems.Separator),
      Helper.clone(MenuItems.UserProfile),
      Helper.clone(MenuItems.Logout),
    ];
  }

  protected createExternalUserMenuItems(): Array<AppMenuItem> {
    return [
      Helper.clone(MenuItems.Dashboard),
      Helper.clone(MenuItems.Alerts),
      Helper.clone(MenuItems.InsightsExternal),
      Helper.clone(MenuItems.Resources),
      Helper.clone(MenuItems.Administration),
      Helper.clone(MenuItems.Separator),
      Helper.clone(MenuItems.UserProfile),
      Helper.clone(MenuItems.Logout),
    ];
  }

  protected filterMenuItemsByAccess(menuItems: Array<AppMenuItem>): Array<AppMenuItem> {
    return menuItems.filter((menuItem) => {
      if(menuItem.accessControlName) {
        return this.accessControlService.checkUserAccess(menuItem.accessControlName);
      }

      if(menuItem.children && menuItem.children.length > 0) {
        menuItem.children = this.filterMenuItemsByAccess(menuItem.children);
      }

      return true;
    });
  }
}
